/*
 * action types
 */

export const REPLACE_VOUCHERS = "REPLACE_VOUCHERS";
export const CLEAR_VOUCHERS = "CLEAR_VOUCHERS";

/*
 * action creators
 */

export const Replace = (values, totalResults, totalPage) => ({ 
    type : REPLACE_VOUCHERS,
    vouchers: values,
    totalResults,
    totalPage
});

export const Clear = () => ({
    type: CLEAR_VOUCHERS
});